<div class="row">
    <div class="container">
        <div *ngIf="!showMultiProduct">
            <h2 class="color-main"> <strong> NÚMERO DE COTIZACIÓN: #{{numeroCotizacion}} </strong> </h2>
            <br>
            <div class="row">
                <div class="col-md-6">
                    <table>
                        <tr>
                            <td style="text-align: center;">
                                <h3 class="color-main"> {{lineaNombre}}</h3>
                                <label>Tipo de línea</label>
                            </td>
                            <td style="text-align: center;" class="border-left">
                                <h3 class="color-main"> {{planNombre}}</h3>
                                <label>Tipo de plan</label>
                            </td>
                            <td style="text-align: center;" class="border-left">
                                <h3 class="color-main"><img src="assets/imagenes/peso.png">
                                    ${{this.setValueMoneda(cuotaInscripcion)}}
                                </h3>
                                <label>Cuota de inscripción</label>
    
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="col-md-6">
                    <table>
                        <tr>
                                <td style="text-align: center;" class="border-left">
                                    <h3 class="color-main"><img src="assets/imagenes/peso.png"> ${{this.setValueMoneda(cuotaTotal)}}
                                    </h3>
                                    <label>Cuota mensual total</label>
                                </td>
                            <td style="text-align: center;" class="border-left">
                                <img width="75px" src="{{imgPrograma}}">
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-xs-12 col-md-1 col-lg-3">
                    <mat-label>Contratante es Beneficiario</mat-label>
                </div>
                <div class="col-xs-12 col-md-1 col-lg-2">
                    <mat-label>{{contratanteBeneficiario}}</mat-label>
                </div>
            </div>
            <br>
            <h1 class="color-main">
                Detalle pago mensual
            </h1>
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-striped">
                        <tbody>
                            <tr *ngFor="let item of listDetallePagoMensual; let i = index">
                                <td>
                                    <label>
                                        {{i + 1}}
                                    </label>
                                </td>
                                <td>
                                    <label>
                                        {{item.beneficiario}}
                                    </label>
                                </td>
                                <td class="color-main" *ngIf="codigo_tipo_plan === 'F'">
                                    <label>
                                        <strong>FAMILIAR: ${{ this.setValueMoneda( item.valor1) }} </strong>
                                    </label>
                                </td>
                                <td class="color-main">
                                    <label>
                                        <strong>ASOCIADO: ${{ this.setValueMoneda( codigo_tipo_plan === 'F' ?
                                            item.valor2 :
                                            item.valor1) }} </strong>
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br>
            <h1 class="color-main">
                Valor pago anticipado
            </h1>
            <div class="row">
                <div class="col-md-4">
                    <table style="border-radius:20px" class="jumbotron">
                        <tr>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td style="text-align: center;">
                                <h3 class="color-main"><strong>Meses</strong></h3>
                            </td>
                        </tr>
                        <tr>
                            <td style="color: transparent;">.</td>
                        </tr>
                        <tr *ngFor="let descueto of detalle_descuentos">
                            <td style="text-align: center;">
                                <label>
                                    <strong>{{descueto.cantidad_mes}} meses</strong>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td style="height: 30px;"></td>
                        </tr>
                    </table>
                </div>
                <div class="col-md-4">
                    <table style="border-radius:20px" class="jumbotron">
                        <tr>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td colspan="2" style="text-align: center;">
                                <h3 class="color-main"><strong>Valor descuento pago anticipado</strong></h3>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: center;" *ngIf="ocultarPlanFamiliar">
                                <label>
                                    <strong>Familiar</strong>
                                </label>
                            </td>
                            <td style="text-align: center;" *ngIf="ocultarPlanAsociado">
                                <label>
                                    <strong>Asociado</strong>
                                </label>
                            </td>
                        </tr>
                        <tr *ngFor="let descueto of detalle_descuentos; let i = index" >
                            <td style="text-align: center;" *ngIf="ocultarPlanFamiliar">
                                <label>
                                    ${{this.valorMoneda(descueto.valor_descuento_familiar, false, descueto.cantidad_mes)}}
                                </label>
                            </td>
                            <td class="border-left" style="text-align: center;" *ngIf="ocultarPlanAsociado">
                                <label>
                                    ${{this.valorMoneda(descueto.valor_descuento_asociado, false, descueto.cantidad_mes)}}
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td style="height: 30px;"></td>
                        </tr>
                    </table>
                </div>
                <div class="col-md-4">
                    <table style="background-color: #0372b9;border-radius:20px" class="jumbotron">
                        <tr>
                            <td style="height: 30px;"></td>
                        </tr>
                        <tr>
                            <td colspan="2" style="text-align: center">
                                <h3 style="color: white !important;" class="color-main">
                                    <strong>
                                        Valor a pagar anticipado
                                    </strong>
                                </h3>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: center;color: white;" *ngIf="ocultarPlanFamiliar">
                                <label>
                                    <strong>Familiar</strong>
                                </label>
                            </td>
                            <td style="text-align: center;color: white;" *ngIf="ocultarPlanAsociado">
                                <label>
                                    <strong>Asociado</strong>
                                </label>
                            </td>
                        </tr>
                        <tr *ngFor="let descueto of detalle_descuentos" >
                            <td style="text-align: center;color: white;" *ngIf="ocultarPlanFamiliar">
                                <label>
                                    ${{this.valorMoneda(descueto.valor_pago_anticipado_familiar, false, descueto.cantidad_mes)}}
                                </label>
                            </td>
                            <td class="border-left" style="text-align: center;color: white;" *ngIf="ocultarPlanAsociado">
                                <label>
                                    ${{this.valorMoneda(descueto.valor_pago_anticipado_asociado, false, descueto.cantidad_mes)}}
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <td style="height: 30px;"></td>
                        </tr>
                    </table>
    
                </div>
            </div>
        </div>
        <div *ngIf="showMultiProduct">
            <app-quotation-multiple [numeroCotizacion]="numeroCotizacion" [detalle_descuentos]="detalle_descuentos" [listLineaTable]="multiProduct" [dataCampania]="dataCampania"></app-quotation-multiple>
        </div>
        <div class="row m-0">
            <div style="text-align: end;" class="col-md-4 offset-md-8">
                <button type="button" (click)="goBack()"
                    style="margin-left: 0px;margin-top: 10px;margin-bottom: 20px;background-color: #0372b9;"
                    class="btn btn-primary">Volver atrás</button>
            </div>
        </div>
    </div>
</div>